import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { PartialUiConfiguration } from '~/app/market-config/models/car-confi-ui-configuration';

const q6: PartialCarConfiguration = {
	combinations: ['trimLine', 'paint[bodyPaint]', 'rims', 'interiorPackages', 'packages', 'equipmentHighlights'],
};

const q6etron_2025_GF: PartialCarConfiguration = {
	...q6,
};

const sq6etron_2025_GF: PartialCarConfiguration = {
	...q6,
};

const q6_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: true,
	showAccessoriesExclusive: true,
};

const q6etron_2025_GF_ui: PartialUiConfiguration = {
	...q6_ui,
};

const sq6etron_2025_GF_ui: PartialUiConfiguration = {
	...q6_ui,
};

export { q6etron_2025_GF, q6etron_2025_GF_ui, sq6etron_2025_GF, sq6etron_2025_GF_ui };
